export const SecurityAndPrivacy = () => {
  return (
    <>
      <p className="caption">Last updated on Feb 5, 2026</p>
      <p>
        Translator Consortium values your privacy and only collects personally identifiable
        information (PII) for the purposes of creating an account. This site automatically
        gathers basic usage data (like IP address, browser type, and pages visited) via
        Google Analytics to improve functionality and user experience — no PII is collected
        in this process. NCATS uses cookies in compliance with federal guidelines (OMB
        M-10-22) to support site performance and analytics, and users can disable cookies
        without losing access. Personal information shared with NCATS is safeguarded
        according to the Privacy Act of 1974, and only authorized personnel may access it.
        For more details, please visit the full{" "}
        <a href="https://ncats.nih.gov/privacy" target="_blank" rel="noreferrer">NCATS Privacy Notice</a>.
      </p>
    </>
  );
}

